import { render } from "./ModalNotifyThanksPointDenial.vue?vue&type=template&id=2cf0522f&scoped=true&ts=true"
import script from "./ModalNotifyThanksPointDenial.vue?vue&type=script&lang=ts"
export * from "./ModalNotifyThanksPointDenial.vue?vue&type=script&lang=ts"

import "./ModalNotifyThanksPointDenial.vue?vue&type=style&index=0&id=2cf0522f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf0522f"]])

export default __exports__